// Regla 3x3 del IMSS para Horas Extras
export const REGLA_3X3_IMSS = {
  SOLO_DOBLES: 1,
  DOBLES_Y_TRIPLES: 2
};

export const REGLA_3X3_IMSS_OPTIONS = [
  { value: 1, text: 'Solo Extras Dobles' },
  { value: 2, text: 'Tomar dobles y triples' }
];

// Manejo de Horas Extras Dobles
export const MANEJO_HORAS_DOBLES = {
  LIMITAR_3_DIARIAS: 1,
  LIMITAR_9_SEMANALES: 2
};

export const MANEJO_HORAS_DOBLES_OPTIONS = [
  { value: 1, text: 'Limitar 3 horas diarias' },
  { value: 2, text: 'Limitar 9 horas semana' }
];

// Tipo de Día Descanso
export const TIPO_DIA_DESCANSO = {
  NO_PAGAR: 1,
  DESCANSO_TRABAJADO: 2,
  EXTRAS_TOPE_DIARIO: 3,
  EXTRAS_TOPE_SEMANAL: 4
};

export const TIPO_DIA_DESCANSO_OPTIONS = [
  { value: 1, text: 'No pagar' },
  { value: 2, text: 'Descanso Trabajado' },
  { value: 3, text: 'Extras con tope Diario' },
  { value: 4, text: 'Extras con Tope semanal' }
];

// Tipo de Día Festivo
export const TIPO_DIA_FESTIVO = {
  NO_PAGAR: 1,
  FESTIVO_TRABAJADO: 2,
  DESCANSO_TRABAJADO: 3,
  EXTRAS_TOPE_DIARIO: 4,
  EXTRAS_TOPE_SEMANAL: 5
};

export const TIPO_DIA_FESTIVO_OPTIONS = [
  { value: 1, text: 'No pagar' },
  { value: 2, text: 'Festivo Trabajado' },
  { value: 3, text: 'Descanso Trabajado' },
  { value: 4, text: 'Extras con tope Diario' },
  { value: 5, text: 'Extras con Tope semanal' }
];

// Días de la Semana
export const DIAS_SEMANA = {
  LUNES: 1,
  MARTES: 2,
  MIERCOLES: 3,
  JUEVES: 4,
  VIERNES: 5,
  SABADO: 6,
  DOMINGO: 7
};

export const DIAS_SEMANA_OPTIONS = [
  { value: 1, text: 'Lunes' },
  { value: 2, text: 'Martes' },
  { value: 3, text: 'Miércoles' },
  { value: 4, text: 'Jueves' },
  { value: 5, text: 'Viernes' },
  { value: 6, text: 'Sábado' },
  { value: 7, text: 'Domingo' }
];